import i18n from '@/plugins/i18n'
import dayjs from 'dayjs'
import * as $number from '@/util/number'

// 其他on的功能
export function getOtherOn(record) {
  if (!record || Object.keys(record).length === 0) return ''
  // --- 顯示順序 ---
  // 補盲上桌
  // Auto-Straddle
  // 多次發牌 : 玩家選擇
  // 經典保險
  // BombPot
  // 72o
  // 魷魚遊戲
  // 壽司遊戲
  // All-in展示
  // 瞇牌 : 落後瞇
  // 延遲看牌
  // GPS限制
  // IP限制
  const onList = [
    record.setting.tableBlindSetting.isBlindFill
      ? i18n.global.t('isBlindFill')
      : null,
    record.setting.tableBlindSetting.isStraddle
      ? i18n.global.t('isStraddle')
      : null,
    record.setting.tableBlindSetting.isBombPot
      ? i18n.global.t('isBombPot')
      : null,
    record.setting.extraSetting?.businessMode !== 'none'
      ? `${i18n.global.t('businessMode')}: ${i18n.global.t(`businessMode_${record.setting.extraSetting.businessMode}`)}`
      : null,
    record.setting.extraSetting?.insuranceMode !== 'none'
      ? `${i18n.global.t('insuranceMode')}: ${i18n.global.t(`insuranceScope_${record.setting.extraSetting.insuranceScope || 'standard'}`)}`
      : null,
    record.setting.extraSetting.hand72o ? i18n.global.t('hand72o') : null,
    record.setting.extraSetting.squidBounty ? i18n.global.t('squid') : null,
    record.setting.extraSetting.isShowAllInOutsAndWinRate
      ? i18n.global.t('isShowAllInOutsAndWinRate')
      : null,
    record.setting.extraSetting?.squintMode !== 'none'
      ? `${i18n.global.t('squintMode')}: ${i18n.global.t(`squintMode_${record.setting.extraSetting.squintMode}`)}`
      : null,
    record.setting.antiCheatSetting.isPreFlopDelay
      ? i18n.global.t('delayCheck')
      : null,
    record.setting.playerSetting.isGpsLimit
      ? i18n.global.t('isGpsLimit')
      : null,
    record.setting.playerSetting.isIpLimit ? i18n.global.t('isIpLimit') : null,
    record.setting.playerSetting.canSimulator
      ? i18n.global.t('canSimulator')
      : null,
  ].filter(Boolean)
  return onList.join('、')
}

// 競技場牌桌其他on的功能
export function getArenaOtherOn(record) {
  if (!record || Object.keys(record).length === 0) return ''

  // --- 顯示順序 ---
  // 補盲上桌
  // Auto-Straddle
  // 多次發牌 : 玩家選擇
  // 經典保險
  // BombPot
  // 72o
  // 魷魚遊戲
  // 壽司遊戲
  // All-in展示
  // 瞇牌 : 落後瞇
  // 延遲看牌
  // GPS限制
  // IP限制
  const onList = [
    record.onSettingFuncInfo.isBlindFill ? i18n.global.t('isBlindFill') : null,
    record.onSettingFuncInfo.isStraddle ? i18n.global.t('isStraddle') : null,
    record.onSettingFuncInfo?.businessMode !== 'none'
      ? `${i18n.global.t('businessMode')}: ${i18n.global.t(`businessMode_${record.onSettingFuncInfo.businessMode}`)}`
      : null,
    record.onSettingFuncInfo?.insuranceMode !== 'none'
      ? `${i18n.global.t('insuranceMode')}: ${i18n.global.t(`insuranceMode_${record.onSettingFuncInfo.insuranceMode}`)}`
      : null,
    record.onSettingFuncInfo.isBombPot ? i18n.global.t('isBombPot') : null,
    record.onSettingFuncInfo.hand72o ? i18n.global.t('hand72o') : null,
    record.onSettingFuncInfo.isSquid ? i18n.global.t('squid') : null,
    record.onSettingFuncInfo.isShowAllInOutsAndWinRate
      ? i18n.global.t('isShowAllInOutsAndWinRate')
      : null,
    record.onSettingFuncInfo?.squintMode !== 'none'
      ? `${i18n.global.t('squintMode')}: ${i18n.global.t(`squintMode_${record.onSettingFuncInfo.squintMode}`)}`
      : null,
    record.onSettingFuncInfo.isPreFlopDelay
      ? i18n.global.t('delayCheck')
      : null,
    record.onSettingFuncInfo.isGpsLimit ? i18n.global.t('isGpsLimit') : null,
    record.onSettingFuncInfo.isIpLimit ? i18n.global.t('isIpLimit') : null,
    record.onSettingFuncInfo.canSimulator
      ? i18n.global.t('canSimulator')
      : null,
  ].filter(Boolean)
  return onList.join('、')
}

// 取得小盲(盲注)
export function getSmallBlind(record) {
  // 短排只顯示前注
  if (['AOF_SHORT_DECK', 'SHORT_DECK'].includes(record.gameCode)) {
    // 如果isDoubleAnte為 true，括弧前面要再放一次前注金額
    if (record.setting.tableBlindSetting.isDoubleAnte) {
      return $number.formatNum(record.ante) + ` (${$number.formatNum(record.ante)})`
    } else {
      return `(${$number.formatNum(record.ante)})`
    }
  } else {
    let text = `${$number.formatNum(record.smallBlind)}/${$number.formatNum(record.smallBlind * 2)}`

    // 如果有強抓，則顯示第三個數值為 大盲再*2
    if (record.setting.tableBlindSetting.isStraddle) {
      text += `/${$number.formatNum(record.smallBlind * 4)}`
    }

    // 如果有前注，則括號內顯示前注
    if (record.ante > 0) {
      text += ` (${$number.formatNum(record.ante)})`
    }

    // 如果isDoubleAnte為 true，括弧前面要再放一次前注金額
    if (record.setting.tableBlindSetting.isDoubleAnte) {
      return $number.formatNum(record.ante) + `(${$number.formatNum(record.ante)})`
    } 

    return text
  }
}

// 取得服務費
export function getServiceFee(record) {
  switch (record.setting.feeSetting.roundFeeMode) {
    case 'none':
      return 'Off'
    case 'percent':
      return i18n.global.t('feeService_percent', {
        type: i18n.global.t(
          `feeSettingType_${record.setting.feeSetting.percentMode.type}`
        ),
        number: record.setting.feeSetting.percentMode.percent,
      })
    case 'fixed':
      return i18n.global.t('feeService_fixed', {
        type: i18n.global.t(
          `feeSettingType_${record.setting.feeSetting.fixedMode.type}`
        ),
        number: record.setting.feeSetting.fixedMode.greaterFee,
      })
  }
}

export function getAgentDetail(record) {
  const lines = []

  if (['agent1'].includes(record.agentType)) {
    lines.push(
      `${i18n.global.t('agentType_agent2')}: ${$number.formatter(record.agent2Count)}`
    )
  }
  if (['agent1', 'agent2'].includes(record.agentType)) {
    lines.push(
      `${i18n.global.t('agentType_agent3')}: ${$number.formatter(record.agent3Count)}`
    )
  }
  if (['agent1', 'agent2', 'agent3'].includes(record.agentType)) {
    lines.push(
      `${i18n.global.t('agentType_member')}: ${$number.formatter(record.memberCount)}`
    )
  }
  if (!['member', 'agent3'].includes(record.agentType)) {
    lines.push(
      `${i18n.global.t('total')}: ${$number.formatter(record.totalCount)}`
    )
  }

  return lines.join('\n')
}

// 代理列表/代理明細 共用：admin/agent/management/export 的回應轉成 CSV 分組資料
// （代理列表匯出＝依搜尋條件的多筆代理；代理明細匯出＝帶 userId 精確比對，回應只有一組）
export function buildAgentExportGroups(agents, residentCountryList = []) {
  const $t = i18n.global.t
  const getCountryLabel = (imgUrl) => {
    if (!imgUrl) return ''
    const abbr = residentCountryList.find((item) => item.imgUrl === imgUrl)?.abbr
    return abbr ? $t(`country_${abbr}`) : ''
  }
  return agents.map((agent) => ({
    groupName: agent.agentName,
    summaryRows: [
      [$t('reportPrintDate'), dayjs().format('YYYY-MM-DD HH:mm:ss')],
      [$t('reportDateRange'), `${agent.dateStart} ~ ${agent.dateEnd}`],
      [$t('totalPublicWinLose'), $number.formatter(agent.totalPublicWinLose)],
      [$t('totalPublicCommission100'), $number.formatter(agent.totalPublicCommission)],
      [$t('publicCommissionRateLabel'), `${agent.publicCommissionRate * 100}%`],
      [$t('publicCommissionAfterLabel'), $number.formatter(agent.publicCommissionAfter)],
      [$t('totalPublicInsurance100'), $number.formatter(agent.totalPublicInsurance)],
      [$t('publicInsuranceRateLabel'), `${agent.publicInsuranceRate * 100}%`],
      [$t('publicInsuranceAfterLabel'), $number.formatter(agent.publicInsuranceAfter)],
      [$t('totalArenaWinLose'), $number.formatter(agent.totalArenaWinLose)],
      [$t('totalArenaCommission100'), $number.formatter(agent.totalArenaCommission)],
      [$t('arenaCommissionRateLabel'), `${agent.arenaCommissionRate * 100}%`],
      [$t('arenaCommissionAfterLabel'), $number.formatter(agent.arenaCommissionAfter)],
      [$t('grandTotalLabel'), $number.formatter(agent.grandTotal)],
    ],
    tableColumns: [
      { title: 'ID', dataIndex: 'userId' },
      { title: $t('name'), dataIndex: 'nickname' },
      {
        title: $t('identity'),
        dataIndex: 'agentType',
        getValue: ({ record }) => $t(`agentType_${record.agentType}`),
      },
      {
        title: $t('residentCountryCsvLabel'),
        dataIndex: 'residentCountry',
        getValue: ({ record }) => getCountryLabel(record.residentCountry),
      },
      {
        title: $t('publicWinLoseIntervalCsvLabel'),
        dataIndex: 'publicWinLose',
        getValue: ({ record }) => $number.formatter(record.publicWinLose),
      },
      {
        title: $t('publicServiceFeeIntervalCsvLabel'),
        dataIndex: 'publicCommission',
        getValue: ({ record }) => $number.formatter(record.publicCommission),
      },
      {
        title: $t('insuranceFeeIntervalCsvLabel'),
        dataIndex: 'publicInsurance',
        getValue: ({ record }) => $number.formatter(record.publicInsurance),
      },
      {
        title: $t('arenaWinLoseIntervalCsvLabel'),
        dataIndex: 'arenaWinLose',
        getValue: ({ record }) => $number.formatter(record.arenaWinLose),
      },
      {
        title: $t('arenaFeeCsvLabel'),
        dataIndex: 'arenaCommission',
        getValue: ({ record }) => $number.formatter(record.arenaCommission),
      },
    ],
    tableData: agent.rows,
  }))
}

// 公共牌顯示格式化
export function getBoardDisplay(board) {
  if (!Array.isArray(board)) return ''
  return board
    .map(
      (item) =>
        `${i18n.global.t(item.substr(1, 1))}${item.substr(0, 1) === 'T' ? '10' : item.substr(0, 1)}`
    )
    .join('、')
}
